enum RewardStatus {
  None = 'None',
  Available = 'Available',
  Redeemed = 'Redeemed',
}

export default RewardStatus;
